// extracted by mini-css-extract-plugin
export default {"badge":"InternalTestingBadge-module__badge_P3ZMR"};